/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Scroll_To_PanInputs */

const en_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll to pan`)
};

const ar_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرّر للتحريك`)
};

const bn_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ক্রল করে প্যান করুন`)
};

const de_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Schwenken scrollen`)
};

const es_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazarse para desplazarse`)
};

const fr_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire défiler jusqu'au panoramique`)
};

const pt_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role para deslocar`)
};

const zh_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`滚动到平移`)
};

const tr_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydırmak için kaydırın`)
};

const ru_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прокрутите для панорамирования`)
};

const pl_pc_scroll_to_pan = /** @type {(inputs: Pc_Scroll_To_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przewiń, aby przesunąć`)
};

/**
* | output |
* | --- |
* | "Scroll to pan" |
*
* @param {Pc_Scroll_To_PanInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const pc_scroll_to_pan = /** @type {((inputs?: Pc_Scroll_To_PanInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Scroll_To_PanInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_pc_scroll_to_pan(inputs)
	if (locale === "bn") return bn_pc_scroll_to_pan(inputs)
	if (locale === "de") return de_pc_scroll_to_pan(inputs)
	if (locale === "es") return es_pc_scroll_to_pan(inputs)
	if (locale === "fr") return fr_pc_scroll_to_pan(inputs)
	if (locale === "pt") return pt_pc_scroll_to_pan(inputs)
	if (locale === "zh") return zh_pc_scroll_to_pan(inputs)
	if (locale === "tr") return tr_pc_scroll_to_pan(inputs)
	if (locale === "ru") return ru_pc_scroll_to_pan(inputs)
	if (locale === "pl") return pl_pc_scroll_to_pan(inputs)
	return en_pc_scroll_to_pan(inputs)
});